import axios from "axios";
import { getUserFromLS } from "../utils/getUserFromLS";
import { IContactIntelligence } from "../Types/account";

export const getContactsPerAccount = (accountId: string, callback: (response: IContactIntelligence[]) => void, errorCallback) => {
    const user = getUserFromLS()
    const URL = `${import.meta.env.VITE_API_BASE_URL}/contact_intelligence/account/${accountId}`;
    return axios(URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${user.access_token}`
      }
    })
        .then((response) => {
        if (callback != null) {
            callback(response.data as IContactIntelligence[]);
        }
        })
        .catch((error) => {
        // catch error
        if (errorCallback != null) {
            errorCallback(error);
        }
    });
};